import gql from 'graphql-tag'

export const SINGLE_TEAM_MEMBER_BY_SLUG = gql`
query GetTeamMemberBySlug($slug: String!) {
  teanMembers(filters: { slug: { eq: $slug } }) {
    data {
      id
      attributes {
        firstName
        lastName
        slug
        position
        knownFor
        Description
        Image {
          data {
            attributes {
              url
              alternativeText
              formats
            }
          }
        }
        badgeIcon {
          data {
            attributes {
              url
              alternativeText
              formats
            }
          }
        }
        marqueeText
        seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}
`
